/**
 * Created by Jerker Nord on 2020-08-11.
 */
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ISpinConfig} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../MonkeysGoldSoundConfig";

export class MonkeysGoldReels extends Reels {

    private _gameMode:string;
    private _nextGameMode:string;

    constructor() {
        super();
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onModeParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onModeParsed(event.params[0]));
    }

    protected onModeParsed(data:ParsedServerData):void {
        this._gameMode = data.mode;
        this._nextGameMode = data.nextMode;
    }

    protected onSpinStart(config:ISpinConfig):void {
        super.onSpinStart(config);

        if(!this.isNextAvalanche()) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.REEL_SPIN_OUT)});
        }
    }

    protected onStopSpin(stopData:{ quickStop:boolean; fastSpin:boolean }):void {
        super.onStopSpin(stopData);
        if(!this.isAvalanche()) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.REEL_SPIN_IN)});
        }
    }

    private isAvalanche():boolean {
        return this._gameMode === GameMode.NORMAL_AVALANCHE || this._gameMode === GameMode.FREESPIN_AVALANCHE;
    }

    private isNextAvalanche():boolean {
        return this._nextGameMode === GameMode.NORMAL_AVALANCHE || this._nextGameMode === GameMode.FREESPIN_AVALANCHE;
    }
}